export default {
  date: 'December 30, 2025',
  title: '2025 Year in Review',
  description: '2025 has been a defining year for our team — a year of scale, innovation, and measurable impact for developers, real estate professionals, and commercial projects worldwide.',
  metaTitle: '',
  metaDescription: 'Getfloorplan 2025 Year in Review: 130,000+ floor plans processed, 10M+ m² visualized, 37 new features, and 7 products launched. See how AI visualization helps developers sell real estate faster.',
  id: 'year-review',
  jsx: () => (
    <div class='novelty__text'>
      <p>2025 has been a defining year for our team — a year of scale, innovation, and measurable impact for developers, real estate professionals, and commercial projects worldwide.</p>
      <p>Over the past year, we focused on one goal: helping our clients visualize, present, and sell spaces faster and more effectively. The results speak for themselves.</p>
      <p>
        <b>2025 at a Glance</b>
      </p>
      <ul style='margin-left: 50px'>
        <li class='margin-none'>130,000+ floor plan levels processed across residential and commercial projects</li>
        <li class='margin-none'>37+ new features rolled out, improving speed, quality, and flexibility</li>
        <li class='margin-none'>7 new products launched to support diverse real estate use cases</li>
        <li class='margin-none'>100+ large-scale projects delivered, each with 1,000+ levels</li>
        <li class='margin-none'>500,000+ client work hours saved through automation and ready-to-use visuals</li>
        <li class='margin-none'>Expansion into 21 new cities and countries, strengthening our global presence</li>
        <li class='margin-none'>10,000,000+ m² of total floor plan area processed</li>
      </ul>
      <p>
        <b>What This Means for Our Clients</b>
      </p>
      <p>
        These milestones reflect more than growth — they represent real business value. Faster approvals, stronger presentations, scalable workflows, and clearer communication with investors and buyers. From single buildings to city-scale developments, our solutions helped teams move from plans to
        decisions with confidence.
      </p>
      <p>As we look ahead to 2026, we remain focused on building tools that simplify complexity, accelerate sales, and set new standards for real estate visualization.</p>
      <p>Thank you for being part of our journey.</p>
    </div>
  ),
  thumb: 'news/68.webp',
};
